import type { useCart } from '@order/hooks';
import { useFeatureFlag } from '@order/LaunchDarkly';

import type { CheckoutPayload } from '../../Checkout.utils';
import { applyCredit, withTip } from '../../Checkout.utils';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Reusable hook that returns the current order ledger along with additional tip and credit info.
 */
export const useCheckoutLedger = (params: UseCheckoutLedgerParams) => {
  const { cart, payload, credit } = params;

  const shouldApplyPickupTip = useFeatureFlag(
    'cels-754-enable-tipping-native-pickup',
  );

  const withAppliedTip = withTip({ cart, payload, shouldApplyPickupTip });

  return { ledger: applyCredit(withAppliedTip, credit) };
};

// ─── UseCheckoutLedgerParams ─────────────────────────────────────────────────

type UseCheckoutLedgerParams = {
  readonly cart: ReturnType<typeof useCart>['cart'];
  readonly payload: CheckoutPayload;
  readonly credit: number;
};
